module.exports = __webpack_public_path__ + "static/media/uni-logo.77e75417.png";